<template>
    <section id="page-wat-is" class="page">
        <div class="page__content">
            <div id="page-wat-is__intro">
                <h1>Maar wat is een hybride docent?</h1>
            </div>
            <div class="container">
                <div class="row">
                    <div class="col-2-sm"></div>
                    <div class="col-10-sm">
                        <h2>Een hybride docent ...</h2>
                    </div>
                </div>
                <div class="row page-wat-is__bullet-row">
                    <div class="col-2-sm page-wat-is__arrow-bullet">
                        <span class="fa fa-arrow-right" aria-hidden="true"></span>
                    </div>
                    <div class="col-10-sm page-wat-is__list-item">
                        <p>Combineert gelijktijdig twee of meer (onderwijs)banen of (onderwijs)rollen;</p>
                    </div>
                </div>
                <div class="row page-wat-is__bullet-row">
                    <div class="col-2-sm page-wat-is__arrow-bullet">
                        <span class="fa fa-arrow-right" aria-hidden="true"></span>
                    </div>
                    <div class="col-10-sm page-wat-is__list-item">
                        <p>heeft een hoofdbaan (meeste uren) als docent welke wordt gecombineerd met een baan in loondienst of als zelfstandige;</p>
                    </div>
                </div>
                <div class="row page-wat-is__bullet-row">
                    <div class="col-2-sm page-wat-is__arrow-bullet">
                        <span class="fa fa-arrow-right" aria-hidden="true"></span>
                    </div>
                    <div class="col-10-sm page-wat-is__list-item">
                        <p>of andersom: dan is het docentschap de tweede baan en werkt men in de hoofdbaan elders in loondienst of zelfstandige;</p>
                    </div>
                </div>

                <div class="row">
                    <div class="col-2-sm"></div>
                    <div class="col-10-sm">
                        <h2>En verder:</h2>
                    </div>
                </div>
                <div class="row page-wat-is__bullet-row">
                    <div class="col-2-sm page-wat-is__arrow-bullet">
                        <span class="fa fa-arrow-right" aria-hidden="true"></span>
                    </div>
                    <div class="col-10-sm page-wat-is__list-item">
                        <p>Hoeveel uur er in meerdere banen wordt gewerkt is niet relevant;</p>
                    </div>
                </div>
                <div class="row page-wat-is__bullet-row">
                    <div class="col-2-sm page-wat-is__arrow-bullet">
                        <span class="fa fa-arrow-right" aria-hidden="true"></span>
                    </div>
                    <div class="col-10-sm page-wat-is__list-item">
                        <p>de contractvorm in elk van de banen is niet relevant;</p>
                    </div>
                </div>
                <div class="row page-wat-is__bullet-row">
                    <div class="col-2-sm page-wat-is__arrow-bullet">
                        <span class="fa fa-arrow-right" aria-hidden="true"></span>
                    </div>
                    <div class="col-10-sm page-wat-is__list-item">
                        <p>het hybride docentschap kan ook een tijdelijke (afgesproken) combinatie zijn, maar gaat verder dan bijvoorbeeld gastdocentschap.</p>
                    </div>
                </div>

                <div class="row">
                    <div class="col-2-sm"></div>
                    <div class="col-10-sm list-select__title">
                        <page-next-button v-on:click="nextHandler"></page-next-button>
                    </div>
                </div>
            </div>
        </div>

    </section>
</template>
<style lang="stylus">
    @require "../../styles/variables.styl"

    #page-wat-is
        .page__block
            position relative
            padding 0 20%
            display flex
            margin-bottom 50px

        .page__block-item
            position relative
            opacity 1

    .page-wat-is__text
        transform scale(0)
        transition transform .7s
        &.page-wat-is__text--active
            transform scale(1)

    .page-wat-is__teacher
        width 20%
        height 100px
        left calc(-20vw - 20vw * 1/0.6)
        background-image url('../../assets/images/docent-man-150.png')
        transition left .7s
        .page__block--active &
            left 0

    .page-wat-is__quote
        width 80%
        padding-left 20px
        left calc(80vw + 20vw * 1/0.6)
        text-align left
        transition left .7s .5s
        .page__block--active  &
            left 0

    .page-wat-is__arrow-bullet
        text-align right
        & span
            margin-right 1em
    .page-wat-is__list-item
        text-align left
        font-size 1.1em
</style>
<script>
    const ScrollMagic = require('ScrollMagic');
    const TimelineMax = require('TimelineMax');
    import page from './page';

    export default {
        mixins: [page],
        data() {
            return {
            }
        },
        mounted() {

        }
    }
</script>



// WEBPACK FOOTER //
// page-wat-is-1.vue?0388a266